import React, { useState } from 'react';
import { extractErrorMessage } from '../lib/errors';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import GoogleAuthButton from '../components/GoogleAuthButton';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { login } = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back');
      nav('/app');
    } catch (err) {
      toast.error(extractErrorMessage(err, 'Login failed'));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-full border border-[#d4a94a] flex items-center justify-center">
            <span className="font-display text-[#d4a94a] text-xl font-semibold leading-none">R</span>
          </div>
          <span className="font-display text-2xl text-zinc-100">Reachly</span>
        </Link>
        <Card className="bg-[#111110] border-zinc-900 p-8">
          <h1 className="font-display text-2xl text-zinc-100">Welcome back.</h1>
          <p className="text-sm text-zinc-500 mt-1">Sign in to your campaigns.</p>
          <div className="mt-6">
            <GoogleAuthButton intent="signin" testid="login-google-btn"/>
            <div className="mt-6 flex items-center gap-3 text-[11px] uppercase tracking-widest text-zinc-600">
              <div className="h-px flex-1 bg-zinc-900"/>
              or
              <div className="h-px flex-1 bg-zinc-900"/>
            </div>
          </div>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label className="text-zinc-300">Email</Label>
              <Input type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-1.5 bg-[#0a0a0b] border-zinc-800 text-zinc-100 focus-visible:ring-[#d4a94a]" placeholder="you@example.com"/>
            </div>
            <div>
              <div className="flex items-baseline justify-between">
                <Label className="text-zinc-300">Password</Label>
                <Link to="/forgot-password" className="text-xs text-zinc-500 hover:text-[#f5d67a]" data-testid="forgot-password-link">Forgot password?</Link>
              </div>
              <Input type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="mt-1.5 bg-[#0a0a0b] border-zinc-800 text-zinc-100 focus-visible:ring-[#d4a94a]" placeholder="••••••••"/>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#d4a94a] hover:bg-[#e5bb5c] text-black font-medium">
              {loading ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
          <div className="mt-6 text-sm text-zinc-500 text-center">
            New to Reachly? <Link to="/signup" className="text-[#f5d67a] hover:underline">Create an account</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
